function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useCallback, useRef, useEffect } from 'react';
import { InputIcon } from '@cbhq/cds-web/controls/InputIcon';
import { ANALYTICS_KEY } from '../../constants.js';
import { useClickOutside } from '../../hooks/useClickOutside.js';
import '../Div/index.js';
import { Pressable } from '../Button.js';
import { Text } from '../Text.js';
import { SelectOptions } from './SelectOptions.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function SelectInput({
  optionValues,
  initialValue,
  label,
  onChange,
  isError,
  errorMessage,
  selectRef,
  bordered,
  children
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  const _useState3 = useState(optionValues?.find(opt => opt.value === initialValue)),
    _useState4 = _slicedToArray(_useState3, 2),
    selectValue = _useState4[0],
    setSelectValue = _useState4[1];
  const changeHandler = useCallback(option => {
    setSelectValue(option);
    setDropdownOpen(false);
    if (onChange && option.value) onChange(option.value);
  }, [onChange]);

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const openDropDown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const containerRef = useRef(null);
  useClickOutside(() => setDropdownOpen(false), containerRef, isDropdownOpen);
  useEffect(() => {
    if (selectRef) {
      selectRef.current = {
        changeHandler,
        setSelectValue
      };
    }
  }, [changeHandler, selectRef]);
  return /*#__PURE__*/jsxs(Div, {
    flexDirection: "column",
    position: "relative",
    width: "100%",
    minWidth: 240,
    ref: containerRef,
    "data-qa": ANALYTICS_KEY.Select,
    children: [/*#__PURE__*/jsxs(Div, {
      alignItems: "center",
      gap: 0.5,
      flexGrow: 1,
      css: {
        '> button': {
          overflow: 'hidden'
        }
      },
      children: [/*#__PURE__*/jsx(Pressable, {
        as: "button",
        background: "background",
        onPress: openDropDown,
        borderRadius: "rounded",
        borderColor: "transparent",
        noScaleOnPress: true,
        width: "100%",
        children: /*#__PURE__*/jsxs(Div, {
          gap: 0.5,
          alignItems: "center",
          bordered: bordered,
          height: bordered ? '40px' : '100%',
          borderColor: isError ? 'negative' : isDropdownOpen ? 'primary' : 'lineHeavy',
          borderRadius: "rounded",
          spacingStart: 2,
          spacingVertical: 2,
          overflow: "hidden",
          flexGrow: 1,
          children: [/*#__PURE__*/jsx(Div, {
            flexShrink: 0,
            children: /*#__PURE__*/jsx(Text, {
              variant: "headline",
              as: "p",
              color: "foregroundMuted",
              children: label
            })
          }), /*#__PURE__*/jsx(Div, {
            flexGrow: 1,
            flexShrink: 1,
            overflow: "hidden",
            css: {
              textAlign: 'left'
            },
            children: /*#__PURE__*/jsx(Text, {
              variant: "headline",
              spacingVertical: 0.5,
              as: "p",
              color: "foreground",
              overflow: "truncate",
              children: selectValue?.label
            })
          }), /*#__PURE__*/jsx(InputIcon, {
            name: isDropdownOpen ? 'caretUp' : 'caretDown',
            color: isDropdownOpen ? 'primary' : 'foreground'
          })]
        })
      }), children && /*#__PURE__*/
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      jsx(Div, {
        spacingEnd: 1,
        onClick: e => e.preventDefault(),
        children: children
      })]
    }), isDropdownOpen && /*#__PURE__*/jsx(SelectOptions, {
      top: containerRef.current?.offsetHeight,
      changeHandler: changeHandler,
      optionValues: optionValues,
      selectedOption: selectValue
    }), isError && /*#__PURE__*/jsx(Text, {
      variant: "label2",
      as: "p",
      color: "negative",
      children: errorMessage
    })]
  });
}
export { SelectInput };
//# sourceMappingURL=SelectInput.js.map
